import { gql } from '@apollo/client';
const PROFILE = gql `
  query Profile {
    me {
      id
      email
      username
      avatar
      maintenance
    }
  }
`;
export default PROFILE;
